module.exports = __webpack_public_path__ + "static/media/flow-jump-mobile.43dc814a.png";